module.exports = __webpack_public_path__ + "img/info.96d7a9e9.svg";